import React from "react"

import BaseSvgIcon from "../Base"

const PersonSearch = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="10 12 20 20" fill="none">
      <g fill="#402aff" clipPath="url(#a)">
        <path d="M19 21c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4-4 1.7909-4 4 1.7909 4 4 4M19.35 23.009c-2.73-.1-8.35 1.26-8.35 3.99v2h9.54c-2.47-2.76-1.23-5.89-1.19-5.99M28.43 27.02c.36-.59.57-1.28.57-2.02 0-2.21-1.79-4-4-4s-4 1.79-4 4 1.79 4 4 4c.74 0 1.43-.22 2.02-.57L29.59 31 31 29.59zM25 27c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M9 9h24v24H9z" />
        </clipPath>
      </defs>
    </BaseSvgIcon>
  )
}

export default PersonSearch
